(function () {
  'use strict';

  // "27,5x120" (cm) → m² por unidade. NaN se o metafield faltar ou for inválido.
  function parseUnitArea(sizeString) {
    if (!sizeString) return NaN;
    var parts = sizeString.split('x').map(function (part) {
      return parseFloat(part.trim().replace(',', '.'));
    });
    if (parts.length < 2 || !isFinite(parts[0]) || !isFinite(parts[1]) || parts[0] <= 0 || parts[1] <= 0) {
      return NaN;
    }
    return (parts[0] / 100) * (parts[1] / 100);
  }

  // Substitui o primeiro número do template pela quantidade calculada
  // (ex.: "Precisa de 1 und." → "Precisa de 7 und.").
  function fillNumber(template, value) {
    if (/\d+([.,]\d+)?/.test(template)) {
      return template.replace(/\d+([.,]\d+)?/, value);
    }
    return value + ' ' + template;
  }

  function initCalculator(wrapper) {
    if (wrapper.dataset.calcInit === 'true') return;

    var widthInput = wrapper.querySelector('.calculator__width-input');
    var heightInput = wrapper.querySelector('.calculator__height-input');
    var result = wrapper.querySelector('.calculator__result');
    if (!widthInput || !heightInput || !result) return;

    var unitArea = parseUnitArea(wrapper.dataset.productSize);
    if (!isFinite(unitArea)) return;

    wrapper.dataset.calcInit = 'true';

    function parseInput(value) {
      if (!value) return NaN;
      value = value.replace(',', '.');
      if (!/^\d*\.?\d*$/.test(value)) return NaN;
      return parseFloat(value);
    }

    function sanitizeInput(input) {
      var cleaned = input.value.replace(/[^0-9.,]/g, '');
      // Só reescreve se mudou — evita saltos do cursor ao digitar.
      if (cleaned !== input.value) input.value = cleaned;
    }

    function updateResult() {
      sanitizeInput(widthInput);
      sanitizeInput(heightInput);

      var width = parseInput(widthInput.value);
      var height = parseInput(heightInput.value);

      if (isFinite(width) && isFinite(height) && width > 0 && height > 0) {
        var needed = Math.max(Math.ceil((width * height) / unitArea), 1);
        result.textContent = fillNumber(wrapper.dataset.resultTemplate || '', needed);
      } else {
        result.textContent = '';
      }
    }

    widthInput.addEventListener('input', updateResult);
    heightInput.addEventListener('input', updateResult);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.calculator__wrapper[data-product-size]').forEach(initCalculator);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
